import { IPayoutRule, IPayTableSymbol } from '@GFTypes/Responses/AuthenticateResponse';

export interface IData {
    [key: string]: Partial<IPayTableSymbol & { name: string; description: string }>;
}
export interface IBlockDesc {
    paylines?: {
        count: number[];
        multiplier: number[];
    }[];
    symbolId: number | undefined;
    isRolesPaytable: boolean;
}

export interface ISymbolOrderItem {
    id: number;
    multiplier: number;
    symbolID?: number;
    symbolName?: string | number | undefined;
    symbolDescription?: string | undefined;
    basePaytable?: IPayoutRule[] | undefined;
    symbolDescriptionInner?: boolean;
    blockDescription?: {
        dom: IBlockDescriptionItem[];
        raw: string;
    };
}

export interface IBlockDescriptionItem {
    lineNumber: number;
    lineLength: number;
    lineString: string;
}

export interface IMaxPaytableString {
    block: number;
    value: number;
}

export interface IPaytableSymbolDescription {
    paytableData:
        | undefined
        | {
              dom: IBlockDescriptionItem[];
              raw: string;
          };
    paytableIndex: number;
    maxStringData: IMaxPaytableString;
    textFieldCallback: Function;
}

export interface IPaytable {
    data: IData;
    order: Array<ISymbolOrderItem>;
    maxPaytableString: IMaxPaytableString;
    blockFontSize: undefined | number;
}

export const PAYTABLE_STATE_DEFAULTS = {
    data: {},
    order: [],
    maxPaytableString: { block: 0, value: 0 },
    blockFontSize: undefined
};
